__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "agent-experience-portal";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] = scope[name] || {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult?.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("@datadog/browser-logs", "7.5.0", () => (Promise.all([__webpack_require__.e(48), __webpack_require__.e(242)]).then(() => (() => (__webpack_require__(43242))))));
			register("@datadog/browser-rum", "7.5.0", () => (Promise.all([__webpack_require__.e(48), __webpack_require__.e(396)]).then(() => (() => (__webpack_require__(82396))))));
			register("@mui/material", "5.18.0", () => (Promise.all([__webpack_require__.e(214), __webpack_require__.e(615), __webpack_require__.e(868), __webpack_require__.e(716), __webpack_require__.e(594)]).then(() => (() => (__webpack_require__(4615))))));
			register("@reduxjs/toolkit", "2.8.2", () => (__webpack_require__.e(88).then(() => (() => (__webpack_require__(67088))))));
			register("amazon-connect-chatjs", "5.1.0", () => (__webpack_require__.e(153).then(() => (() => (__webpack_require__(31153))))));
			register("amazon-connect-streams", "2.25.1", () => (__webpack_require__.e(726).then(() => (() => (__webpack_require__(44726))))));
			register("aws-amplify", "6.17.0", () => (Promise.all([__webpack_require__.e(938), __webpack_require__.e(974)]).then(() => (() => (__webpack_require__(74974))))));
			register("axios-retry", "0", () => (__webpack_require__.e(368).then(() => (() => (__webpack_require__(95368))))));
			register("axios", "1.19.0", () => (__webpack_require__.e(544).then(() => (() => (__webpack_require__(27544))))));
			register("graphql-tag", "2.12.6", () => (Promise.all([__webpack_require__.e(176), __webpack_require__.e(516)]).then(() => (() => (__webpack_require__(2135))))));
			register("graphql", "15.8.0", () => (__webpack_require__.e(272).then(() => (() => (__webpack_require__(89272))))));
			register("graphql", "16.11.0", () => (__webpack_require__.e(942).then(() => (() => (__webpack_require__(23942))))));
			register("jwt-decode", "3.1.2", () => (__webpack_require__.e(765).then(() => (() => (__webpack_require__(6765))))));
			register("mesh-component-library", "2.101.0", () => (Promise.all([__webpack_require__.e(214), __webpack_require__.e(735), __webpack_require__.e(716), __webpack_require__.e(594), __webpack_require__.e(635)]).then(() => (() => (__webpack_require__(30735))))));
			register("mesh-icon-library", "3.4.1", () => (Promise.all([__webpack_require__.e(34), __webpack_require__.e(716)]).then(() => (() => (__webpack_require__(8034))))));
			register("pkce-challenge", "4.1.0", () => (__webpack_require__.e(880).then(() => (() => (__webpack_require__(73880))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(716)]).then(() => (() => (__webpack_require__(40961))))));
			register("react-redux", "9.2.0", () => (Promise.all([__webpack_require__.e(468), __webpack_require__.e(716)]).then(() => (() => (__webpack_require__(71468))))));
			register("react", "18.3.1", () => (__webpack_require__.e(540).then(() => (() => (__webpack_require__(96540))))));
			register("redux-persist", "6.0.0", () => (__webpack_require__.e(385).then(() => (() => (__webpack_require__(41385))))));
			register("styled-components", "5.3.11", () => (Promise.all([__webpack_require__.e(716), __webpack_require__.e(94)]).then(() => (() => (__webpack_require__(78094))))));
			initExternal(29989);
			initExternal(51227);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};